import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import './i18n'

import 'primereact/resources/primereact.min.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'

import '@fortawesome/fontawesome-svg-core/index'
import '@fortawesome/free-solid-svg-icons/index'
import '@fortawesome/react-fontawesome/index'
import './styles/theme/theme.scss'

import '@fortawesome/fontawesome-free/css/all.css'

// eslint-disable-next-line import/order
import PrimeReact from 'primereact/api'
import store from './redux/store'

PrimeReact.ripple = true

const root = createRoot(
	document.getElementById('root') as HTMLDivElement
)

root.render(
	<StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App/>
			</BrowserRouter>
		</Provider>
	</StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()